// src/components/CreateCarrier.js

import React, {
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";

import {
  useNavigate,
} from "react-router-dom";

import axios from "../axiosConfig";

import Select from "react-select";

import "../styles/CreateCarrier.css";

import {
  customSelectStyles,
} from "../styles/reactSelectStyles";

import {
  FaArrowLeft,
  FaCalendarAlt,
  FaCreditCard,
  FaFileAlt,
  FaFrown,
  FaMapMarkerAlt,
  FaMeh,
  FaPlus,
  FaSave,
  FaShieldAlt,
  FaSmile,
  FaTrashAlt,
  FaTruck,
  FaUpload,
} from "react-icons/fa";

import {
  useTranslation,
} from "react-i18next";

/* =========================================================
   CreateCarrier
   ========================================================= */

function CreateCarrier() {
  const {
    t,
  } = useTranslation(
    "create_carrier"
  );

  const navigate =
    useNavigate();

  /* =========================================================
     Options
     ========================================================= */

  const paymentOptions =
    useMemo(
      () => [
        {
          value:
            "Bank Transfer",

          label:
            t(
              "options.payment_methods.bank_transfer"
            ),
        },
        {
          value:
            "Credit/Debit Card",

          label:
            t(
              "options.payment_methods.card"
            ),
        },
        {
          value:
            "Cash",

          label:
            t(
              "options.payment_methods.cash"
            ),
        },
        {
          value:
            "MB WAY",

          label:
            t(
              "options.payment_methods.mbway"
            ),
        },
        {
          value:
            "PayPal",

          label:
            t(
              "options.payment_methods.paypal"
            ),
        },
      ],
      [t]
    );

  const countryOptions =
    useMemo(
      () => [
        {
          value: "Austria",
          label:
            t(
              "options.countries.Austria"
            ),
          code: "at",
        },
        {
          value: "Belgium",
          label:
            t(
              "options.countries.Belgium"
            ),
          code: "be",
        },
        {
          value: "Croatia",
          label:
            t(
              "options.countries.Croatia"
            ),
          code: "hr",
        },
        {
          value:
            "Czech Republic",
          label:
            t(
              "options.countries.Czech Republic"
            ),
          code: "cz",
        },
        {
          value: "Denmark",
          label:
            t(
              "options.countries.Denmark"
            ),
          code: "dk",
        },
        {
          value: "Estonia",
          label:
            t(
              "options.countries.Estonia"
            ),
          code: "ee",
        },
        {
          value: "Finland",
          label:
            t(
              "options.countries.Finland"
            ),
          code: "fi",
        },
        {
          value: "France",
          label:
            t(
              "options.countries.France"
            ),
          code: "fr",
        },
        {
          value: "Germany",
          label:
            t(
              "options.countries.Germany"
            ),
          code: "de",
        },
        {
          value: "Hungary",
          label:
            t(
              "options.countries.Hungary"
            ),
          code: "hu",
        },
        {
          value: "Italy",
          label:
            t(
              "options.countries.Italy"
            ),
          code: "it",
        },
        {
          value: "Netherlands",
          label:
            t(
              "options.countries.Netherlands"
            ),
          code: "nl",
        },
        {
          value: "Norway",
          label:
            t(
              "options.countries.Norway"
            ),
          code: "no",
        },
        {
          value: "Poland",
          label:
            t(
              "options.countries.Poland"
            ),
          code: "pl",
        },
        {
          value: "Portugal",
          label:
            t(
              "options.countries.Portugal"
            ),
          code: "pt",
        },
        {
          value: "Spain",
          label:
            t(
              "options.countries.Spain"
            ),
          code: "es",
        },
        {
          value: "Sweden",
          label:
            t(
              "options.countries.Sweden"
            ),
          code: "se",
        },
        {
          value:
            "Switzerland",
          label:
            t(
              "options.countries.Switzerland"
            ),
          code: "ch",
        },
        {
          value:
            "United Kingdom",
          label:
            t(
              "options.countries.United Kingdom"
            ),
          code: "gb",
        },
      ],
      [t]
    );

  const phoneNumberOptions =
    useMemo(
      () => [
        {
          value: "+43",
          label:
            `${t(
              "options.countries.Austria"
            )} (+43)`,
          code: "at",
        },
        {
          value: "+32",
          label:
            `${t(
              "options.countries.Belgium"
            )} (+32)`,
          code: "be",
        },
        {
          value: "+385",
          label:
            `${t(
              "options.countries.Croatia"
            )} (+385)`,
          code: "hr",
        },
        {
          value: "+420",
          label:
            `${t(
              "options.countries.Czech Republic"
            )} (+420)`,
          code: "cz",
        },
        {
          value: "+45",
          label:
            `${t(
              "options.countries.Denmark"
            )} (+45)`,
          code: "dk",
        },
        {
          value: "+372",
          label:
            `${t(
              "options.countries.Estonia"
            )} (+372)`,
          code: "ee",
        },
        {
          value: "+358",
          label:
            `${t(
              "options.countries.Finland"
            )} (+358)`,
          code: "fi",
        },
        {
          value: "+33",
          label:
            `${t(
              "options.countries.France"
            )} (+33)`,
          code: "fr",
        },
        {
          value: "+49",
          label:
            `${t(
              "options.countries.Germany"
            )} (+49)`,
          code: "de",
        },
        {
          value: "+36",
          label:
            `${t(
              "options.countries.Hungary"
            )} (+36)`,
          code: "hu",
        },
        {
          value: "+39",
          label:
            `${t(
              "options.countries.Italy"
            )} (+39)`,
          code: "it",
        },
        {
          value: "+31",
          label:
            `${t(
              "options.countries.Netherlands"
            )} (+31)`,
          code: "nl",
        },
        {
          value: "+47",
          label:
            `${t(
              "options.countries.Norway"
            )} (+47)`,
          code: "no",
        },
        {
          value: "+48",
          label:
            `${t(
              "options.countries.Poland"
            )} (+48)`,
          code: "pl",
        },
        {
          value: "+351",
          label:
            `${t(
              "options.countries.Portugal"
            )} (+351)`,
          code: "pt",
        },
        {
          value: "+34",
          label:
            `${t(
              "options.countries.Spain"
            )} (+34)`,
          code: "es",
        },
        {
          value: "+46",
          label:
            `${t(
              "options.countries.Sweden"
            )} (+46)`,
          code: "se",
        },
        {
          value: "+41",
          label:
            `${t(
              "options.countries.Switzerland"
            )} (+41)`,
          code: "ch",
        },
        {
          value: "+44",
          label:
            `${t(
              "options.countries.United Kingdom"
            )} (+44)`,
          code: "gb",
        },
      ],
      [t]
    );

  const currencyOptions =
    useMemo(
      () => [
        {
          value: "EUR",
          label:
            t(
              "options.currencies.EUR"
            ),
          code: "eu",
        },
        {
          value: "USD",
          label:
            t(
              "options.currencies.USD"
            ),
          code: "us",
        },
        {
          value: "GBP",
          label:
            t(
              "options.currencies.GBP"
            ),
          code: "gb",
        },
        {
          value: "CHF",
          label:
            t(
              "options.currencies.CHF"
            ),
          code: "ch",
        },
        {
          value: "PLN",
          label:
            t(
              "options.currencies.PLN"
            ),
          code: "pl",
        },
        {
          value: "NOK",
          label:
            t(
              "options.currencies.NOK"
            ),
          code: "no",
        },
        {
          value: "SEK",
          label:
            t(
              "options.currencies.SEK"
            ),
          code: "se",
        },
      ],
      [t]
    );

  const TRUCK_TYPE_OPTIONS =
    useMemo(
      () => [
        {
          value:
            "Curtain Side Truck (Tautliner)",
          label:
            t(
              "options.truck_types.tautliner"
            ),
        },
        {
          value:
            "Refrigerated Truck (Frigo)",
          label:
            t(
              "options.truck_types.frigo"
            ),
        },
        {
          value:
            "Articulated Dump Truck",
          label:
            t(
              "options.truck_types.articulated_dump"
            ),
        },
        {
          value:
            "Box Truck / Van",
          label:
            t(
              "options.truck_types.box_truck"
            ),
        },
        {
          value:
            "Car Hauler",
          label:
            t(
              "options.truck_types.car_hauler"
            ),
        },
        {
          value:
            "Cattle Carrier",
          label:
            t(
              "options.truck_types.cattle"
            ),
        },
        {
          value:
            "Cement Mixer Truck",
          label:
            t(
              "options.truck_types.cement_mixer"
            ),
        },
        {
          value:
            "Clothing Hanging Carrier",
          label:
            t(
              "options.truck_types.clothing"
            ),
        },
        {
          value:
            "Concrete Pump Truck",
          label:
            t(
              "options.truck_types.concrete_pump"
            ),
        },
        {
          value:
            "Container Truck",
          label:
            t(
              "options.truck_types.container"
            ),
        },
        {
          value:
            "Crane Truck",
          label:
            t(
              "options.truck_types.crane"
            ),
        },
        {
          value:
            "Double Decker Truck",
          label:
            t(
              "options.truck_types.double_decker"
            ),
        },
        {
          value:
            "Drum Carrier",
          label:
            t(
              "options.truck_types.drum"
            ),
        },
        {
          value:
            "Dump Truck (Dump Carrier)",
          label:
            t(
              "options.truck_types.dump"
            ),
        },
        {
          value:
            "Flatbed Truck",
          label:
            t(
              "options.truck_types.flatbed"
            ),
        },
        {
          value:
            "Heavy Hauler",
          label:
            t(
              "options.truck_types.heavy_hauler"
            ),
        },
        {
          value:
            "Logging Truck",
          label:
            t(
              "options.truck_types.logging"
            ),
        },
        {
          value:
            "Lowboy Truck (Special Transport)",
          label:
            t(
              "options.truck_types.lowboy"
            ),
        },
        {
          value:
            "Open Box Truck",
          label:
            t(
              "options.truck_types.open_box"
            ),
        },
        {
          value:
            "Pickup Truck",
          label:
            t(
              "options.truck_types.pickup"
            ),
        },
        {
          value:
            "Road Train",
          label:
            t(
              "options.truck_types.road_train"
            ),
        },
        {
          value:
            "Tanker Truck (Cistern)",
          label:
            t(
              "options.truck_types.tanker"
            ),
        },
        {
          value:
            "Vehicle Carrier",
          label:
            t(
              "options.truck_types.vehicle_carrier"
            ),
        },
      ],
      [t]
    );

  const SERVICE_AREAS_OPTIONS =
    useMemo(
      () => [
        {
          label:
            t(
              "options.service_area_groups.europe"
            ),

          options: [
            "Austria",
            "Belgium",
            "Bulgaria",
            "Croatia",
            "Cyprus",
            "Czech Republic",
            "Denmark",
            "Estonia",
            "Finland",
            "France",
            "Germany",
            "Greece",
            "Hungary",
            "Ireland",
            "Italy",
            "Latvia",
            "Lithuania",
            "Luxembourg",
            "Malta",
            "Netherlands",
            "Poland",
            "Portugal",
            "Romania",
            "Slovakia",
            "Slovenia",
            "Spain",
            "Sweden",
          ].map(
            (country) => ({
              value:
                country,

              label:
                t(
                  `options.countries.${country}`
                ),
            })
          ),
        },
        {
          label:
            t(
              "options.service_area_groups.united_states"
            ),

          options: [
            "Alabama",
            "Alaska",
            "Arizona",
            "Arkansas",
            "California",
            "Colorado",
            "Connecticut",
            "Delaware",
            "Florida",
            "Georgia",
            "Hawaii",
            "Idaho",
            "Illinois",
            "Indiana",
            "Iowa",
            "Kansas",
            "Kentucky",
            "Louisiana",
            "Maine",
            "Maryland",
            "Massachusetts",
            "Michigan",
            "Minnesota",
            "Mississippi",
            "Missouri",
            "Montana",
            "Nebraska",
            "Nevada",
            "New Hampshire",
            "New Jersey",
            "New Mexico",
            "New York",
            "North Carolina",
            "North Dakota",
            "Ohio",
            "Oklahoma",
            "Oregon",
            "Pennsylvania",
            "Rhode Island",
            "South Carolina",
            "South Dakota",
            "Tennessee",
            "Texas",
            "Utah",
            "Vermont",
            "Virginia",
            "Washington",
            "West Virginia",
            "Wisconsin",
            "Wyoming",
          ].map(
            (state) => ({
              value:
                state,

              label:
                t(
                  `options.us_states.${state}`
                ),
            })
          ),
        },
      ],
      [t]
    );

  const SERVICES_OFFERED_OPTIONS =
    useMemo(
      () =>
        [
          "Container Transport",
          "Dangerous Goods Transport (ADR)",
          "Express or Time-Critical Delivery",
          "Fragile or High-Value Goods Transport",
          "Full Truck Load",
          "Groupage",
          "Intermodal Transportation",
          "Last-Mile Delivery",
          "Livestock Transport",
          "Oversized or Heavy Haul Transport",
          "Reverse Logistics",
          "Specialized Cargo Transport",
          "Temperature-Controlled Transport",
          "Vehicle Transport",
          "Waste Transport",
        ].map(
          (value) => ({
            value,

            label:
              t(
                `options.services_offered.${value}`
              ),
          })
        ),
      [t]
    );

  const PARTNERSHIP_OPTIONS =
    useMemo(
      () => [
        {
          value:
            "Positive",

          label:
            t(
              "options.partnership_history.positive"
            ),

          icon:
            <FaSmile
              color="limegreen"
            />,
        },
        {
          value:
            "Neutral",

          label:
            t(
              "options.partnership_history.neutral"
            ),

          icon:
            <FaMeh
              color="gray"
            />,
        },
        {
          value:
            "Negative",

          label:
            t(
              "options.partnership_history.negative"
            ),

          icon:
            <FaFrown
              color="tomato"
            />,
        },
      ],
      [t]
    );

  const paymentDueDateOptions =
    useMemo(
      () =>
        [
          "same day",
          "1 day",
          "3 days",
          "5 days",
          "10 days",
          "15 days",
          "30 days",
          "45 days",
          "60 days",
          "90 days",
          "120 days",
        ].map(
          (value) => ({
            value,

            label:
              t(
                `options.payment_due_dates.${value.replaceAll(
                  " ",
                  "_"
                )}`
              ),
          })
        ),
      [t]
    );

  const discountOptions =
    useMemo(
      () =>
        [
          ...Array(
            21
          ),
        ].map(
          (
            _,
            index
          ) => ({
            value:
              `${index * 5}%`,

            label:
              `${index * 5}%`,
          })
        ),
      []
    );

  const invoiceDeliveryOptions =
    useMemo(
      () => [
        {
          value:
            "email",

          label:
            t(
              "options.invoice_delivery.email"
            ),
        },
        {
          value:
            "postal",

          label:
            t(
              "options.invoice_delivery.postal"
            ),
        },
        {
          value:
            "download",

          label:
            t(
              "options.invoice_delivery.download"
            ),
        },
      ],
      [t]
    );

  /* =========================================================
     React Select multi-value layout
     ========================================================= */

  const multiSelectHorizontalStyles =
    useMemo(
      () => {
        const base =
          customSelectStyles ||
          {};

        return {
          ...base,

          control: (
            provided,
            state
          ) => ({
            ...(base.control
              ? base.control(
                  provided,
                  state
                )
              : provided),

            minHeight: 40,
            height: 40,

            overflow:
              "hidden",

            alignItems:
              "center",
          }),

          valueContainer: (
            provided,
            state
          ) => ({
            ...(base.valueContainer
              ? base.valueContainer(
                  provided,
                  state
                )
              : provided),

            flexWrap:
              "nowrap",

            overflowX:
              "auto",

            overflowY:
              "hidden",

            whiteSpace:
              "nowrap",

            alignItems:
              "center",

            paddingTop: 0,
            paddingBottom: 0,

            paddingRight: 68,

            gap: 5,
          }),

          multiValue: (
            provided,
            state
          ) => ({
            ...(base.multiValue
              ? base.multiValue(
                  provided,
                  state
                )
              : provided),

            flex:
              "0 0 auto",

            maxWidth:
              "none",

            margin: 0,
          }),

          multiValueLabel: (
            provided,
            state
          ) => ({
            ...(base.multiValueLabel
              ? base.multiValueLabel(
                  provided,
                  state
                )
              : provided),

            maxWidth: 145,

            overflow:
              "hidden",

            textOverflow:
              "ellipsis",

            whiteSpace:
              "nowrap",
          }),

          indicatorsContainer: (
            provided,
            state
          ) => ({
            ...(base.indicatorsContainer
              ? base.indicatorsContainer(
                  provided,
                  state
                )
              : provided),

            alignItems:
              "center",
          }),
        };
      },
      []
    );

  /* =========================================================
     State
     ========================================================= */

  const [
    formData,
    setFormData,
  ] = useState({
    companyName: "",
    fleetSize: "",
    truckTypes: [],
    serviceAreas: [],
    loadCapacityPerTruck:
      "",
    driversEmployed:
      "",
    servicesOffered: [],
    partnershipHistory:
      "",

    address: "",
    city: "",
    postalCode: "",
    country: "",

    mainContactName: "",
    mainContactTitle:
      "",
    contactEmail: "",
    phoneNumberCountryCode:
      "",
    phoneNumber: "",

    contacts: [],

    website: "",

    communityLicenseExpiry:
      "",

    cmrInsuranceExpiry:
      "",

    motorThirdPartyLiabilityInsuranceExpiry:
      "",

    ComprehensiveVehicleInsuranceExpiryDate:
      "",

    bankName: "",
    accountHolderName: "",
    accountNumber: "",
    iban: "",
    swift_bic: "",
    currency: "",

    paymentMethodsAccepted:
      [],

    paymentDueDate: "",
    discountTerms: "",

    latePaymentPenalties:
      "",

    VAT_TaxInformation:
      "",

    iva: "",

    invoiceDeliveryMethod:
      [],

    invoiceEmail: "",

    additionalNotes: "",
  });

  const [
    files,
    setFiles,
  ] = useState({
    communityLicense:
      null,

    cmrInsurance:
      null,

    motorThirdPartyLiabilityInsurance:
      null,

    comprehensiveVehicleInsurance:
      null,
  });

  const [
    errorMessage,
    setErrorMessage,
  ] = useState("");

  const [
    errors,
    setErrors,
  ] = useState({});

  const [
    showSuccessPopup,
    setShowSuccessPopup,
  ] = useState(false);

  const [
    isSubmitting,
    setIsSubmitting,
  ] = useState(false);

  const [
    activeSection,
    setActiveSection,
  ] = useState(
    "basic"
  );

  const sectionRefs =
    useRef({});

  const MAX_FILE_SIZE_MB =
    5;

  /* =========================================================
     Helpers
     ========================================================= */

  const isValidUrl = (
    url
  ) =>
    /^(https?:\/\/)?([a-z0-9.-]+)\.[a-z]{2,}(\/[^\s]*)?$/i.test(
      url
    );

  const countOnlyAlphaNumeric =
    (
      value = ""
    ) =>
      String(
        value
      ).replace(
        /[^a-zA-Z0-9]/g,
        ""
      ).length;

  const clearFieldError =
    (
      fieldName
    ) => {
      setErrors(
        (previous) => {
          if (
            !previous[
              fieldName
            ]
          ) {
            return previous;
          }

          const updated = {
            ...previous,
          };

          delete updated[
            fieldName
          ];

          return updated;
        }
      );
    };

  const handleInputChange =
    (
      event
    ) => {
      const {
        name,
        value,
      } =
        event.target;

      setFormData(
        (previous) => ({
          ...previous,
          [name]: value,
        })
      );

      setErrors(
        (previous) => {
          const updated = {
            ...previous,
          };

          if (
            name ===
            "iban"
          ) {
            if (
              !String(
                value
              ).trim()
            ) {
              delete updated.iban;
            } else if (
              countOnlyAlphaNumeric(
                value
              ) < 15
            ) {
              updated.iban =
                t(
                  "errors.min.iban"
                );
            } else {
              delete updated.iban;
            }

            return updated;
          }

          if (
            name ===
            "swift_bic"
          ) {
            if (
              !String(
                value
              ).trim()
            ) {
              delete updated.swift_bic;
            } else if (
              countOnlyAlphaNumeric(
                value
              ) < 8
            ) {
              updated.swift_bic =
                t(
                  "errors.min.swift_bic"
                );
            } else {
              delete updated.swift_bic;
            }

            return updated;
          }

          if (
            name ===
            "iva"
          ) {
            const normalized =
              String(
                value
              )
                .trim()
                .replace(
                  ",",
                  "."
                );

            const parsed =
              Number(
                normalized
              );

            if (
              !String(
                value
              ).trim()
            ) {
              delete updated.iva;
            } else if (
              !Number.isFinite(
                parsed
              )
            ) {
              updated.iva =
                t(
                  "errors.invalid.iva"
                );
            } else if (
              parsed < 0 ||
              parsed > 100
            ) {
              updated.iva =
                t(
                  "errors.range.iva"
                );
            } else {
              delete updated.iva;
            }

            return updated;
          }

          delete updated[
            name
          ];

          return updated;
        }
      );
    };

  const handleCountryChange =
    (
      selectedOption
    ) => {
      setFormData(
        (previous) => ({
          ...previous,

          country:
            selectedOption
              ? selectedOption.value
              : "",
        })
      );

      clearFieldError(
        "country"
      );
    };

  const handlePhoneCodeChange =
    (
      selectedOption
    ) => {
      setFormData(
        (previous) => ({
          ...previous,

          phoneNumberCountryCode:
            selectedOption
              ? selectedOption.value
              : "",
        })
      );

      clearFieldError(
        "phoneNumberCountryCode"
      );
    };

  const handleCurrencyChange =
    (
      selectedOption
    ) => {
      setFormData(
        (previous) => ({
          ...previous,

          currency:
            selectedOption
              ?.value ||
            "",
        })
      );

      clearFieldError(
        "currency"
      );
    };

  /* =========================================================
     Contacts
     ========================================================= */

  const handleAddContact =
    () => {
      setFormData(
        (previous) => ({
          ...previous,

          contacts: [
            ...(
              previous.contacts ||
              []
            ),

            {
              contactName:
                "",

              contactTitle:
                "",

              contactEmail:
                "",

              phoneNumberCountryCode:
                "",

              phoneNumber:
                "",
            },
          ],
        })
      );
    };

  const handleRemoveContact =
    (
      index
    ) => {
      setFormData(
        (previous) => ({
          ...previous,

          contacts: (
            previous.contacts ||
            []
          ).filter(
            (
              _,
              contactIndex
            ) =>
              contactIndex !==
              index
          ),
        })
      );

      setErrors(
        (previous) => {
          const updated = {
            ...previous,
          };

          Object.keys(
            updated
          ).forEach(
            (key) => {
              if (
                key.startsWith(
                  `contacts-${index}-`
                )
              ) {
                delete updated[
                  key
                ];
              }
            }
          );

          return updated;
        }
      );
    };

  const handleContactChange =
    (
      index,
      field,
      value
    ) => {
      setFormData(
        (previous) => ({
          ...previous,

          contacts: (
            previous.contacts ||
            []
          ).map(
            (
              contact,
              contactIndex
            ) =>
              contactIndex ===
              index
                ? {
                    ...contact,

                    [field]:
                      value,
                  }
                : contact
          ),
        })
      );

      setErrors(
        (previous) => {
          const updated = {
            ...previous,
          };

          delete updated[
            `contacts-${index}-${field}`
          ];

          if (
            field ===
            "contactEmail"
          ) {
            Object.keys(
              updated
            ).forEach(
              (key) => {
                if (
                  key.startsWith(
                    "contacts-"
                  ) &&
                  key.endsWith(
                    "-contactEmail"
                  )
                ) {
                  delete updated[
                    key
                  ];
                }
              }
            );
          }

          return updated;
        }
      );
    };

  /* =========================================================
     Files
     ========================================================= */

  const handleFileChange =
    (
      event
    ) => {
      const selectedFile =
        event.target
          .files?.[0];

      const fieldName =
        event.target
          .name;

      if (
        !selectedFile
      ) {
        return;
      }

      const allowedTypes = [
        "image/jpeg",
        "image/png",
        "application/pdf",
      ];

      if (
        !allowedTypes.includes(
          selectedFile.type
        )
      ) {
        setErrorMessage(
          t(
            "errors.invalid_file_type"
          )
        );

        event.target.value =
          "";

        return;
      }

      if (
        selectedFile.size >
        MAX_FILE_SIZE_MB *
          1024 *
          1024
      ) {
        setErrorMessage(
          t(
            "errors.file_too_large",
            {
              size:
                MAX_FILE_SIZE_MB,
            }
          )
        );

        event.target.value =
          "";

        return;
      }

      if (
        files[
          fieldName
        ] &&
        files[fieldName]
          .name ===
          selectedFile.name &&
        files[fieldName]
          .size ===
          selectedFile.size
      ) {
        return;
      }

      setFiles(
        (previous) => ({
          ...previous,

          [fieldName]:
            selectedFile,
        })
      );

      setErrorMessage(
        ""
      );

      clearFieldError(
        fieldName
      );
    };

  const openLocalFile =
    (
      file
    ) => {
      if (!file) {
        return;
      }

      const fileURL =
        URL.createObjectURL(
          file
        );

      window.open(
        fileURL,
        "_blank",
        "noopener,noreferrer"
      );

      setTimeout(
        () => {
          URL.revokeObjectURL(
            fileURL
          );
        },
        60000
      );
    };

  /* =========================================================
     Validation
     ========================================================= */

  const validateBasic =
    () => {
      const nextErrors =
        {};

      if (
        !String(
          formData.companyName ||
            ""
        ).trim()
      ) {
        nextErrors.companyName =
          t(
            "errors.required.companyName"
          );
      }

      return nextErrors;
    };

  const validateContacts =
    () => {
      const nextErrors =
        {};

      const normalizedEmailMap =
        {};

      (
        formData.contacts ||
        []
      ).forEach(
        (
          contact,
          index
        ) => {
          const trimmedEmail =
            String(
              contact.contactEmail ||
                ""
            ).trim();

          if (
            !trimmedEmail
          ) {
            return;
          }

          const normalizedEmail =
            trimmedEmail.toLowerCase();

          if (
            !normalizedEmailMap[
              normalizedEmail
            ]
          ) {
            normalizedEmailMap[
              normalizedEmail
            ] = [];
          }

          normalizedEmailMap[
            normalizedEmail
          ].push(
            index
          );
        }
      );

      Object.values(
        normalizedEmailMap
      ).forEach(
        (
          indexes
        ) => {
          if (
            indexes.length >
            1
          ) {
            indexes.forEach(
              (
                index
              ) => {
                nextErrors[
                  `contacts-${index}-contactEmail`
                ] =
                  t(
                    "errors.duplicate_contact_email"
                  );
              }
            );
          }
        }
      );

      if (
        String(
          formData.website ||
            ""
        ).trim()
      ) {
        const website =
          String(
            formData.website
          ).trim();

        const withProtocol =
          website.startsWith(
            "http"
          )
            ? website
            : `https://${website}`;

        if (
          !isValidUrl(
            withProtocol
          )
        ) {
          nextErrors.website =
            t(
              "errors.invalid_url"
            );
        }
      }

      return nextErrors;
    };

  const validateDocuments =
    () => {
      const nextErrors =
        {};

      const maxFileSize =
        MAX_FILE_SIZE_MB *
        1024 *
        1024;

      Object.entries(
        files
      ).forEach(
        ([
          key,
          file,
        ]) => {
          if (
            file &&
            file.size >
              maxFileSize
          ) {
            nextErrors[key] =
              t(
                "errors.file_limit"
              );
          }
        }
      );

      return nextErrors;
    };

  const validateBilling =
    () => {
      const nextErrors =
        {};

      if (
        formData.iban &&
        countOnlyAlphaNumeric(
          formData.iban
        ) < 15
      ) {
        nextErrors.iban =
          t(
            "errors.min.iban"
          );
      }

      if (
        formData.accountNumber &&
        formData.accountNumber
          .length < 8
      ) {
        nextErrors.accountNumber =
          t(
            "errors.min.accountNumber"
          );
      }

      if (
        formData.swift_bic &&
        countOnlyAlphaNumeric(
          formData.swift_bic
        ) < 8
      ) {
        nextErrors.swift_bic =
          t(
            "errors.min.swift_bic"
          );
      }

      if (
        String(
          formData.iva ||
            ""
        ).trim()
      ) {
        const normalizedIva =
          String(
            formData.iva
          )
            .trim()
            .replace(
              ",",
              "."
            );

        const parsedIva =
          Number(
            normalizedIva
          );

        if (
          !Number.isFinite(
            parsedIva
          )
        ) {
          nextErrors.iva =
            t(
              "errors.invalid.iva"
            );
        } else if (
          parsedIva < 0 ||
          parsedIva > 100
        ) {
          nextErrors.iva =
            t(
              "errors.range.iva"
            );
        }
      }

      return nextErrors;
    };

  const getSectionFromErrors =
    (
      nextErrors
    ) => {
      const keys =
        Object.keys(
          nextErrors
        );

      if (
        keys.some(
          (key) =>
            [
              "companyName",
              "fleetSize",
              "driversEmployed",
              "truckTypes",
              "loadCapacityPerTruck",
              "serviceAreas",
              "servicesOffered",
              "partnershipHistory",
            ].includes(
              key
            )
        )
      ) {
        return "basic";
      }

      if (
        keys.some(
          (key) =>
            key.startsWith(
              "contacts-"
            ) ||
            [
              "address",
              "city",
              "postalCode",
              "country",
              "website",
              "mainContactName",
              "mainContactTitle",
              "contactEmail",
              "phoneNumberCountryCode",
              "phoneNumber",
            ].includes(
              key
            )
        )
      ) {
        return "contacts";
      }

      if (
        keys.some(
          (key) =>
            [
              "communityLicense",
              "communityLicenseExpiry",
              "cmrInsurance",
              "cmrInsuranceExpiry",
              "motorThirdPartyLiabilityInsurance",
              "motorThirdPartyLiabilityInsuranceExpiry",
              "comprehensiveVehicleInsurance",
              "ComprehensiveVehicleInsuranceExpiryDate",
            ].includes(
              key
            )
        )
      ) {
        return "documents";
      }

      if (
        keys.length >
        0
      ) {
        return "billing";
      }

      return null;
    };

  const validateAll =
    () => {
      const nextErrors =
        {
          ...validateBasic(),

          ...validateContacts(),

          ...validateDocuments(),

          ...validateBilling(),
        };

      setErrors(
        nextErrors
      );

      const section =
        getSectionFromErrors(
          nextErrors
        );

      if (
        section
      ) {
        setTimeout(
          () => {
            scrollToSection(
              section
            );
          },
          0
        );
      }

      return (
        Object.keys(
          nextErrors
        ).length ===
        0
      );
    };

  /* =========================================================
     Section navigation
     ========================================================= */

  const scrollToSection =
    (
      section
    ) => {
      setActiveSection(
        section
      );

      sectionRefs.current[
        section
      ]?.scrollIntoView({
        behavior:
          "smooth",

        block:
          "start",
      });
    };

  useEffect(() => {
    const sectionKeys = [
      "basic",
      "contacts",
      "documents",
      "billing",
    ];

    let animationFrameId =
      null;

    const updateActiveSection =
      () => {
        animationFrameId =
          null;

        /*
         * Linha virtual no viewport.
         *
         * Quando o topo de uma secção passa
         * esta linha, essa secção passa a
         * ser considerada ativa.
         */
        const activationLine =
          190;

        let nextActive =
          "basic";

        for (
          let index = 0;
          index <
          sectionKeys.length;
          index += 1
        ) {
          const key =
            sectionKeys[index];

          const section =
            sectionRefs.current[
              key
            ];

          if (!section) {
            continue;
          }

          const rect =
            section.getBoundingClientRect();

          if (
            rect.top <=
            activationLine
          ) {
            nextActive =
              key;
          } else {
            /*
             * As secções estão por ordem
             * vertical, portanto quando
             * encontramos a primeira que
             * ainda não passou a linha,
             * podemos parar.
             */
            break;
          }
        }

        setActiveSection(
          (
            current
          ) =>
            current ===
            nextActive
              ? current
              : nextActive
        );
      };

    const scheduleUpdate =
      () => {
        if (
          animationFrameId !==
          null
        ) {
          return;
        }

        animationFrameId =
          window.requestAnimationFrame(
            updateActiveSection
          );
      };

    /*
     * Usamos document + capture=true.
     *
     * Assim apanhamos scroll mesmo que
     * o LOADEvo esteja a fazer scroll
     * num container interno e não
     * diretamente no window.
     */
    document.addEventListener(
      "scroll",
      scheduleUpdate,
      true
    );

    window.addEventListener(
      "resize",
      scheduleUpdate
    );

    /*
     * Calcula corretamente a secção
     * logo ao abrir a página.
     */
    updateActiveSection();

    return () => {
      document.removeEventListener(
        "scroll",
        scheduleUpdate,
        true
      );

      window.removeEventListener(
        "resize",
        scheduleUpdate
      );

      if (
        animationFrameId !==
        null
      ) {
        window.cancelAnimationFrame(
          animationFrameId
        );
      }
    };
  }, []);

  const navigationItems =
    useMemo(
      () => [
        {
          key:
            "basic",

          icon:
            <FaTruck />,

          title:
            t(
              "nav.basic"
            ),

          subtitle:
            t(
              "nav.basic_subtitle"
            ),
        },
        {
          key:
            "contacts",

          icon:
            <FaMapMarkerAlt />,

          title:
            t(
              "nav.contacts"
            ),

          subtitle:
            t(
              "nav.contacts_subtitle"
            ),
        },
        {
          key:
            "documents",

          icon:
            <FaShieldAlt />,

          title:
            t(
              "nav.documents"
            ),

          subtitle:
            t(
              "nav.documents_subtitle"
            ),
        },
        {
          key:
            "billing",

          icon:
            <FaCreditCard />,

          title:
            t(
              "nav.billing"
            ),

          subtitle:
            t(
              "nav.billing_subtitle"
            ),
        },
      ],
      [t]
    );

  /* =========================================================
     Submit
     ========================================================= */

  const handleSubmit =
    async (
      event
    ) => {
      event.preventDefault();

      setErrorMessage(
        ""
      );

      if (
        !validateAll()
      ) {
        return;
      }

      const formDataCopy =
        {
          ...formData,
        };

      if (
        formDataCopy.iva !==
          "" &&
        formDataCopy.iva !=
          null
      ) {
        const normalizedIva =
          String(
            formDataCopy.iva
          )
            .trim()
            .replace(
              ",",
              "."
            );

        const parsedIva =
          Number(
            normalizedIva
          );

        if (
          !Number.isFinite(
            parsedIva
          ) ||
          parsedIva < 0 ||
          parsedIva > 100
        ) {
          setErrors(
            (
              previous
            ) => ({
              ...previous,

              iva:
                t(
                  "errors.invalid.iva"
                ),
            })
          );

          scrollToSection(
            "billing"
          );

          return;
        }

        formDataCopy.iva =
          parsedIva.toFixed(
            2
          );
      }

      if (
        formDataCopy.website
      ) {
        const website =
          formDataCopy.website.trim();

        const withProtocol =
          website.startsWith(
            "http"
          )
            ? website
            : `https://${website}`;

        if (
          !isValidUrl(
            withProtocol
          )
        ) {
          setErrors(
            (
              previous
            ) => ({
              ...previous,

              website:
                t(
                  "errors.invalid_url"
                ),
            })
          );

          scrollToSection(
            "contacts"
          );

          return;
        }

        formDataCopy.website =
          withProtocol;
      }

      const maxFileSize =
        MAX_FILE_SIZE_MB *
        1024 *
        1024;

      if (
        (
          files.communityLicense &&
          files.communityLicense
            .size >
            maxFileSize
        ) ||
        (
          files.cmrInsurance &&
          files.cmrInsurance
            .size >
            maxFileSize
        ) ||
        (
          files.motorThirdPartyLiabilityInsurance &&
          files.motorThirdPartyLiabilityInsurance
            .size >
            maxFileSize
        ) ||
        (
          files.comprehensiveVehicleInsurance &&
          files.comprehensiveVehicleInsurance
            .size >
            maxFileSize
        )
      ) {
        setErrorMessage(
          t(
            "errors.file_limit_global"
          )
        );

        scrollToSection(
          "documents"
        );

        return;
      }

      setIsSubmitting(
        true
      );

      try {
        const payload =
          new FormData();

        Object.entries(
          formDataCopy
        ).forEach(
          ([
            key,
            value,
          ]) => {
            if (
              value ===
                "" ||
              value ==
                null
            ) {
              return;
            }

            if (
              key ===
              "contacts"
            ) {
              payload.append(
                key,
                JSON.stringify(
                  value ||
                    []
                )
              );
            } else if (
              Array.isArray(
                value
              )
            ) {
              payload.append(
                key,
                value.join(
                  ","
                )
              );
            } else {
              payload.append(
                key,
                value
              );
            }
          }
        );

        Object.entries(
          files
        ).forEach(
          ([
            key,
            file,
          ]) => {
            if (file) {
              payload.append(
                key,
                file
              );
            }
          }
        );

        const createRes =
          await axios.post(
            "/carriers",
            payload
          );

        const newCarrierId =
          createRes?.data
            ?.id;

        /*
         * Mantemos também a lógica já existente
         * de upload individual dos documentos
         * depois da criação.
         */
        if (
          newCarrierId
        ) {
          const uploadSingleDoc =
            async (
              fieldName,
              file
            ) => {
              if (
                !file
              ) {
                return;
              }

              const docForm =
                new FormData();

              docForm.append(
                fieldName,
                file
              );

              await axios.post(
                `/carriers/${newCarrierId}/upload-documents`,
                docForm,
                {
                  headers: {
                    "Content-Type":
                      "multipart/form-data",
                  },
                }
              );
            };

          await uploadSingleDoc(
            "communityLicense",
            files.communityLicense
          );

          await uploadSingleDoc(
            "cmrInsurance",
            files.cmrInsurance
          );

          await uploadSingleDoc(
            "motorThirdPartyLiabilityInsurance",
            files.motorThirdPartyLiabilityInsurance
          );

          await uploadSingleDoc(
            "comprehensiveVehicleInsurance",
            files.comprehensiveVehicleInsurance
          );
        }

        /* Limpar cache da lista de carriers */
        try {
          const token =
            localStorage.getItem(
              "token"
            ) ||
            localStorage.getItem(
              "authToken"
            ) ||
            sessionStorage.getItem(
              "token"
            ) ||
            sessionStorage.getItem(
              "authToken"
            ) ||
            "";

          let companyId =
            null;

          try {
            const payloadData =
              token
                ? JSON.parse(
                    atob(
                      token
                        .split(
                          "."
                        )[1]
                        .replace(
                          /-/g,
                          "+"
                        )
                        .replace(
                          /_/g,
                          "/"
                        )
                    )
                  )
                : null;

            companyId =
              payloadData
                ?.company_id ??
              payloadData
                ?.companyId ??
              null;
          } catch {
            companyId =
              null;
          }

          const cacheKey =
            companyId
              ? `company:${companyId}:carriers:summary:v1`
              : "company:unknown:carriers:summary:v1";

          window.localStorage.removeItem(
            cacheKey
          );
        } catch {
          // ignore
        }

        setShowSuccessPopup(
          true
        );

        setTimeout(
          () => {
            navigate(
              "/clients?view=carriers"
            );
          },
          1200
        );
      } catch (
        error
      ) {
        setShowSuccessPopup(
          false
        );

        console.error(
          "Error creating carrier:",
          error
        );

        console.error(
          "Error response data:",
          error.response
            ?.data
        );

        console.error(
          "Error response status:",
          error.response
            ?.status
        );

        setErrorMessage(
          error.response
            ?.data
            ?.details
            ?.join(
              " | "
            ) ||
            error.response
              ?.data
              ?.error ||
            error.response
              ?.data
              ?.message ||
            t(
              "messages.created_fail"
            )
        );
      } finally {
        setIsSubmitting(
          false
        );
      }
    };

  /* =========================================================
     Documents config
     ========================================================= */

  const documentRows = [
    {
      fileKey:
        "communityLicense",

      label:
        t(
          "fields.communityLicense.label"
        ),

      expiryName:
        "communityLicenseExpiry",

      expiryValue:
        formData.communityLicenseExpiry,
    },
    {
      fileKey:
        "cmrInsurance",

      label:
        t(
          "fields.cmrInsurance.label"
        ),

      expiryName:
        "cmrInsuranceExpiry",

      expiryValue:
        formData.cmrInsuranceExpiry,
    },
    {
      fileKey:
        "motorThirdPartyLiabilityInsurance",

      label:
        t(
          "fields.mtpl.label"
        ),

      expiryName:
        "motorThirdPartyLiabilityInsuranceExpiry",

      expiryValue:
        formData.motorThirdPartyLiabilityInsuranceExpiry,
    },
    {
      fileKey:
        "comprehensiveVehicleInsurance",

      label:
        t(
          "fields.comprehensive.label"
        ),

      expiryName:
        "ComprehensiveVehicleInsuranceExpiryDate",

      expiryValue:
        formData.ComprehensiveVehicleInsuranceExpiryDate,
    },
  ];

  /* =========================================================
     Render
     ========================================================= */

  return (
    <div className="create-carrier-page">
      {/* =========================
          Success popup
          ========================= */}
      {showSuccessPopup && (
        <div className="create-carrier-successPopup-overlay">
          <div className="create-carrier-successPopup">
            <div className="create-carrier-successPopup-icon">
              ✓
            </div>

            <h3>
              {t(
                "success.createdTitle"
              )}
            </h3>

            <p>
              {t(
                "messages.created_success"
              )}
            </p>

            <button
              type="button"
              onClick={() =>
                navigate(
                  "/clients?view=carriers"
                )
              }
              className="create-carrier-successPopup-btn"
            >
              {t(
                "buttons.ok"
              )}
            </button>
          </div>
        </div>
      )}

      {/* =========================
          Header
          ========================= */}
      <header className="create-carrier-header">
        <div className="create-carrier-header__left">
          <button
            type="button"
            className="create-carrier-back-button"
            onClick={() =>
              navigate(
                "/clients?view=carriers"
              )
            }
            aria-label={t(
              "buttons.back"
            )}
          >
            <FaArrowLeft />
          </button>

          <div className="create-carrier-header__copy">
            <h1>
              {t(
                "header.title"
              )}
            </h1>

            <p>
              {formData.companyName ||
                t(
                  "header.subtitle"
                )}
            </p>
          </div>
        </div>

        <div className="create-carrier-header__actions">
          <button
            type="button"
            className="create-carrier-header-cancel"
            onClick={() =>
              navigate(
                "/clients?view=carriers"
              )
            }
          >
            {t(
              "buttons.cancel"
            )}
          </button>

          <button
            type="submit"
            form="create-carrier-main-form"
            className="create-carrier-header-save"
            disabled={
              isSubmitting
            }
          >
            <FaSave />

            <span>
              {isSubmitting
                ? t(
                    "buttons.creating"
                  )
                : t(
                    "buttons.create"
                  )}
            </span>
          </button>
        </div>
      </header>

      {/* =========================
          Global error
          ========================= */}
      {errorMessage && (
        <div className="create-carrier-global-error">
          {errorMessage}
        </div>
      )}

      {/* =========================
          Main layout
          ========================= */}
      <div className="create-carrier-layout">
        {/* =======================
            Section navigation
            ======================= */}
        <aside className="create-carrier-section-nav">
          <div className="create-carrier-section-nav__inner">
            {navigationItems.map(
              (
                item
              ) => (
                <button
                  type="button"
                  key={
                    item.key
                  }
                  className={`create-carrier-section-nav__item ${
                    activeSection ===
                    item.key
                      ? "is-active"
                      : ""
                  }`}
                  onClick={() =>
                    scrollToSection(
                      item.key
                    )
                  }
                >
                  <span className="create-carrier-section-nav__icon">
                    {
                      item.icon
                    }
                  </span>

                  <span className="create-carrier-section-nav__copy">
                    <strong>
                      {
                        item.title
                      }
                    </strong>

                    <small>
                      {
                        item.subtitle
                      }
                    </small>
                  </span>
                </button>
              )
            )}
          </div>
        </aside>

        {/* =======================
            Form
            ======================= */}
        <form
          id="create-carrier-main-form"
          onSubmit={
            handleSubmit
          }
          className="create-carrier-form"
        >
          {/* =========================================
              BASIC INFORMATION
              ========================================= */}
          <section
            ref={(
              node
            ) => {
              sectionRefs.current.basic =
                node;
            }}
            data-section="basic"
            className="create-carrier-section"
          >
            <div className="create-carrier-section-header">
              <span className="create-carrier-section-header__icon">
                <FaTruck />
              </span>

              <div>
                <h2>
                  {t(
                    "nav.basic"
                  )}
                </h2>

                <p>
                  {t(
                    "section_subtitles.basic"
                  )}
                </p>
              </div>
            </div>

            <div className="create-carrier-grid create-carrier-grid--basic-top">
              <div className="create-carrier-field">
                <label htmlFor="companyName">
                  {t(
                    "fields.companyName.label"
                  )}
                  *
                </label>

                <input
                  type="text"
                  id="companyName"
                  name="companyName"
                  placeholder={t(
                    "fields.companyName.placeholder"
                  )}
                  value={
                    formData.companyName
                  }
                  onChange={
                    handleInputChange
                  }
                  className={`create-carrier-input ${
                    errors.companyName
                      ? "create-carrier-input-error"
                      : ""
                  }`}
                  required
                />

                {errors.companyName && (
                  <p className="create-carrier-field-error">
                    {
                      errors.companyName
                    }
                  </p>
                )}
              </div>

              <div className="create-carrier-field">
                <label htmlFor="fleetSize">
                  {t(
                    "fields.fleetSize.label"
                  )}
                </label>

                <input
                  type="number"
                  id="fleetSize"
                  name="fleetSize"
                  placeholder={t(
                    "fields.fleetSize.placeholder"
                  )}
                  value={
                    formData.fleetSize
                  }
                  onChange={
                    handleInputChange
                  }
                  min="0"
                  className={`create-carrier-input ${
                    errors.fleetSize
                      ? "create-carrier-input-error"
                      : ""
                  }`}
                />

                {errors.fleetSize && (
                  <p className="create-carrier-field-error">
                    {
                      errors.fleetSize
                    }
                  </p>
                )}
              </div>
            </div>

            <div className="create-carrier-grid create-carrier-grid--3">
              <div className="create-carrier-field">
                <label htmlFor="driversEmployed">
                  {t(
                    "fields.driversEmployed.label"
                  )}
                </label>

                <input
                  type="number"
                  id="driversEmployed"
                  name="driversEmployed"
                  placeholder={t(
                    "fields.driversEmployed.placeholder"
                  )}
                  value={
                    formData.driversEmployed
                  }
                  onChange={
                    handleInputChange
                  }
                  min="0"
                  className={`create-carrier-input ${
                    errors.driversEmployed
                      ? "create-carrier-input-error"
                      : ""
                  }`}
                />

                {errors.driversEmployed && (
                  <p className="create-carrier-field-error">
                    {
                      errors.driversEmployed
                    }
                  </p>
                )}
              </div>

              <div className="create-carrier-field">
                <label>
                  {t(
                    "fields.truckTypes.label"
                  )}
                </label>

                <Select
                  options={
                    TRUCK_TYPE_OPTIONS
                  }
                  isMulti
                  value={(
                    formData.truckTypes ||
                    []
                  ).map(
                    (
                      value
                    ) => ({
                      value,

                      label:
                        TRUCK_TYPE_OPTIONS.find(
                          (
                            option
                          ) =>
                            option.value ===
                            value
                        )
                          ?.label ||
                        value,
                    })
                  )}
                  onChange={(
                    selected
                  ) => {
                    setFormData(
                      (
                        previous
                      ) => ({
                        ...previous,

                        truckTypes:
                          selected
                            ? selected.map(
                                (
                                  option
                                ) =>
                                  option.value
                              )
                            : [],
                      })
                    );

                    clearFieldError(
                      "truckTypes"
                    );
                  }}
                  placeholder={t(
                    "fields.truckTypes.placeholder"
                  )}
                  isClearable
                  styles={
                    multiSelectHorizontalStyles
                  }
                  classNamePrefix={
                    errors.truckTypes
                      ? "create-carrier-select-error"
                      : "create-carrier-select"
                  }
                />

                {errors.truckTypes && (
                  <p className="create-carrier-dropdown-field-error">
                    {
                      errors.truckTypes
                    }
                  </p>
                )}
              </div>

              <div className="create-carrier-field">
                <label htmlFor="loadCapacityPerTruck">
                  {t(
                    "fields.loadCapacityPerTruck.label"
                  )}
                </label>

                <input
                  type="number"
                  id="loadCapacityPerTruck"
                  name="loadCapacityPerTruck"
                  placeholder={t(
                    "fields.loadCapacityPerTruck.placeholder"
                  )}
                  value={
                    formData.loadCapacityPerTruck
                  }
                  onChange={
                    handleInputChange
                  }
                  min="0"
                  step="0.01"
                  className={`create-carrier-input ${
                    errors.loadCapacityPerTruck
                      ? "create-carrier-input-error"
                      : ""
                  }`}
                />

                {errors.loadCapacityPerTruck && (
                  <p className="create-carrier-field-error">
                    {
                      errors.loadCapacityPerTruck
                    }
                  </p>
                )}
              </div>
            </div>

            <div className="create-carrier-grid create-carrier-grid--3">
              <div className="create-carrier-field">
                <label>
                  {t(
                    "fields.serviceAreas.label"
                  )}
                </label>

                <Select
                  options={
                    SERVICE_AREAS_OPTIONS
                  }
                  isMulti
                  value={(
                    formData.serviceAreas ||
                    []
                  ).map(
                    (
                      value
                    ) => ({
                      value,

                      label:
                        t(
                          `options.countries.${value}`,
                          {
                            defaultValue:
                              t(
                                `options.us_states.${value}`,
                                {
                                  defaultValue:
                                    value,
                                }
                              ),
                          }
                        ),
                    })
                  )}
                  onChange={(
                    selected
                  ) => {
                    setFormData(
                      (
                        previous
                      ) => ({
                        ...previous,

                        serviceAreas:
                          selected
                            ? selected.map(
                                (
                                  option
                                ) =>
                                  option.value
                              )
                            : [],
                      })
                    );

                    clearFieldError(
                      "serviceAreas"
                    );
                  }}
                  placeholder={t(
                    "fields.serviceAreas.placeholder"
                  )}
                  isClearable
                  styles={
                    multiSelectHorizontalStyles
                  }
                  classNamePrefix={
                    errors.serviceAreas
                      ? "create-carrier-select-error"
                      : "create-carrier-select"
                  }
                />

                {errors.serviceAreas && (
                  <p className="create-carrier-dropdown-field-error">
                    {
                      errors.serviceAreas
                    }
                  </p>
                )}
              </div>

              <div className="create-carrier-field">
                <label>
                  {t(
                    "fields.servicesOffered.label"
                  )}
                </label>

                <Select
                  options={
                    SERVICES_OFFERED_OPTIONS
                  }
                  isMulti
                  value={(
                    formData.servicesOffered ||
                    []
                  ).map(
                    (
                      value
                    ) => ({
                      value,

                      label:
                        t(
                          `options.services_offered.${value}`
                        ),
                    })
                  )}
                  onChange={(
                    selected
                  ) => {
                    setFormData(
                      (
                        previous
                      ) => ({
                        ...previous,

                        servicesOffered:
                          selected
                            ? selected.map(
                                (
                                  option
                                ) =>
                                  option.value
                              )
                            : [],
                      })
                    );

                    clearFieldError(
                      "servicesOffered"
                    );
                  }}
                  placeholder={t(
                    "fields.servicesOffered.placeholder"
                  )}
                  isClearable
                  styles={
                    multiSelectHorizontalStyles
                  }
                  classNamePrefix={
                    errors.servicesOffered
                      ? "create-carrier-select-error"
                      : "create-carrier-select"
                  }
                />

                {errors.servicesOffered && (
                  <p className="create-carrier-dropdown-field-error">
                    {
                      errors.servicesOffered
                    }
                  </p>
                )}
              </div>

              <div className="create-carrier-field">
                <label>
                  {t(
                    "fields.partnershipHistory.label"
                  )}
                </label>

                <Select
                  options={
                    PARTNERSHIP_OPTIONS
                  }
                  value={
                    PARTNERSHIP_OPTIONS.find(
                      (
                        option
                      ) =>
                        option.value ===
                        formData.partnershipHistory
                    ) ||
                    null
                  }
                  onChange={(
                    selected
                  ) => {
                    setFormData(
                      (
                        previous
                      ) => ({
                        ...previous,

                        partnershipHistory:
                          selected
                            ? selected.value
                            : "",
                      })
                    );

                    clearFieldError(
                      "partnershipHistory"
                    );
                  }}
                  placeholder={t(
                    "fields.partnershipHistory.placeholder"
                  )}
                  isClearable
                  isSearchable={
                    false
                  }
                  styles={
                    customSelectStyles
                  }
                  formatOptionLabel={(
                    option
                  ) => (
                    <div className="create-carrier-option-with-icon">
                      {
                        option.icon
                      }

                      <span>
                        {
                          option.label
                        }
                      </span>
                    </div>
                  )}
                  classNamePrefix={
                    errors.partnershipHistory
                      ? "create-carrier-select-error"
                      : "create-carrier-select"
                  }
                />

                {errors.partnershipHistory && (
                  <p className="create-carrier-dropdown-field-error">
                    {
                      errors.partnershipHistory
                    }
                  </p>
                )}
              </div>
            </div>
          </section>

          {/* =========================================
              ADDRESS & CONTACTS
              ========================================= */}
          <section
            ref={(
              node
            ) => {
              sectionRefs.current.contacts =
                node;
            }}
            data-section="contacts"
            className="create-carrier-section"
          >
            <div className="create-carrier-section-header">
              <span className="create-carrier-section-header__icon">
                <FaMapMarkerAlt />
              </span>

              <div>
                <h2>
                  {t(
                    "nav.contacts"
                  )}
                </h2>

                <p>
                  {t(
                    "section_subtitles.contacts"
                  )}
                </p>
              </div>
            </div>

            <div className="create-carrier-grid create-carrier-grid--1">
              <div className="create-carrier-field">
                <label htmlFor="address">
                  {t(
                    "fields.address.label"
                  )}
                </label>

                <input
                  type="text"
                  id="address"
                  name="address"
                  placeholder={t(
                    "fields.address.placeholder"
                  )}
                  value={
                    formData.address
                  }
                  onChange={
                    handleInputChange
                  }
                  className={`create-carrier-input ${
                    errors.address
                      ? "create-carrier-input-error"
                      : ""
                  }`}
                />

                {errors.address && (
                  <p className="create-carrier-field-error">
                    {
                      errors.address
                    }
                  </p>
                )}
              </div>
            </div>

            <div className="create-carrier-grid create-carrier-grid--3">
              <div className="create-carrier-field">
                <label htmlFor="city">
                  {t(
                    "fields.city.label"
                  )}
                </label>

                <input
                  type="text"
                  id="city"
                  name="city"
                  placeholder={t(
                    "fields.city.placeholder"
                  )}
                  value={
                    formData.city
                  }
                  onChange={
                    handleInputChange
                  }
                  className={`create-carrier-input ${
                    errors.city
                      ? "create-carrier-input-error"
                      : ""
                  }`}
                />

                {errors.city && (
                  <p className="create-carrier-field-error">
                    {
                      errors.city
                    }
                  </p>
                )}
              </div>

              <div className="create-carrier-field">
                <label htmlFor="postalCode">
                  {t(
                    "fields.postalCode.label"
                  )}
                </label>

                <input
                  type="text"
                  id="postalCode"
                  name="postalCode"
                  placeholder={t(
                    "fields.postalCode.placeholder"
                  )}
                  value={
                    formData.postalCode
                  }
                  onChange={
                    handleInputChange
                  }
                  className={`create-carrier-input ${
                    errors.postalCode
                      ? "create-carrier-input-error"
                      : ""
                  }`}
                />

                {errors.postalCode && (
                  <p className="create-carrier-field-error">
                    {
                      errors.postalCode
                    }
                  </p>
                )}
              </div>

              <div className="create-carrier-field">
                <label>
                  {t(
                    "fields.country.label"
                  )}
                </label>

                <Select
                  options={
                    countryOptions
                  }
                  value={
                    countryOptions.find(
                      (
                        option
                      ) =>
                        option.value ===
                        formData.country
                    ) ||
                    null
                  }
                  onChange={
                    handleCountryChange
                  }
                  formatOptionLabel={(
                    country
                  ) => (
                    <div className="create-carrier-option-with-icon">
                      <img
                        src={`https://flagcdn.com/w40/${country.code}.png`}
                        alt={
                          country.label
                        }
                        className="create-carrier-option-flag"
                      />

                      <span>
                        {
                          country.label
                        }
                      </span>
                    </div>
                  )}
                  placeholder={t(
                    "fields.country.placeholder"
                  )}
                  isClearable
                  styles={
                    customSelectStyles
                  }
                  classNamePrefix={
                    errors.country
                      ? "create-carrier-select-error"
                      : "create-carrier-select"
                  }
                />

                {errors.country && (
                  <p className="create-carrier-dropdown-field-error">
                    {
                      errors.country
                    }
                  </p>
                )}
              </div>
            </div>

            {/* Website continua presente e opcional */}
            <div className="create-carrier-grid create-carrier-grid--1">
              <div className="create-carrier-field">
                <label htmlFor="website">
                  {t(
                    "fields.website.label"
                  )}
                </label>

                <input
                  type="text"
                  id="website"
                  name="website"
                  placeholder={t(
                    "fields.website.placeholder"
                  )}
                  value={
                    formData.website
                  }
                  onChange={
                    handleInputChange
                  }
                  className={`create-carrier-input ${
                    errors.website
                      ? "create-carrier-input-error"
                      : ""
                  }`}
                />

                {errors.website && (
                  <p className="create-carrier-field-error">
                    {
                      errors.website
                    }
                  </p>
                )}
              </div>
            </div>

            <div className="create-carrier-grid create-carrier-grid--2">
              <div className="create-carrier-field">
                <label htmlFor="mainContactName">
                  {t(
                    "fields.mainContactName.label"
                  )}
                </label>

                <input
                  type="text"
                  id="mainContactName"
                  name="mainContactName"
                  placeholder={t(
                    "fields.mainContactName.placeholder"
                  )}
                  value={
                    formData.mainContactName
                  }
                  onChange={
                    handleInputChange
                  }
                  className={`create-carrier-input ${
                    errors.mainContactName
                      ? "create-carrier-input-error"
                      : ""
                  }`}
                />

                {errors.mainContactName && (
                  <p className="create-carrier-field-error">
                    {
                      errors.mainContactName
                    }
                  </p>
                )}
              </div>

              <div className="create-carrier-field">
                <label htmlFor="mainContactTitle">
                  {t(
                    "fields.mainContactTitle.label"
                  )}
                </label>

                <input
                  type="text"
                  id="mainContactTitle"
                  name="mainContactTitle"
                  placeholder={t(
                    "fields.mainContactTitle.placeholder"
                  )}
                  value={
                    formData.mainContactTitle
                  }
                  onChange={
                    handleInputChange
                  }
                  className={`create-carrier-input ${
                    errors.mainContactTitle
                      ? "create-carrier-input-error"
                      : ""
                  }`}
                />

                {errors.mainContactTitle && (
                  <p className="create-carrier-field-error">
                    {
                      errors.mainContactTitle
                    }
                  </p>
                )}
              </div>
            </div>

            <div className="create-carrier-grid create-carrier-grid--3">
              <div className="create-carrier-field">
                <label htmlFor="contactEmail">
                  {t(
                    "fields.contactEmail.label"
                  )}
                </label>

                <input
                  type="email"
                  id="contactEmail"
                  name="contactEmail"
                  placeholder={t(
                    "fields.contactEmail.placeholder"
                  )}
                  value={
                    formData.contactEmail
                  }
                  onChange={
                    handleInputChange
                  }
                  className={`create-carrier-input ${
                    errors.contactEmail
                      ? "create-carrier-input-error"
                      : ""
                  }`}
                />

                {errors.contactEmail && (
                  <p className="create-carrier-field-error">
                    {
                      errors.contactEmail
                    }
                  </p>
                )}
              </div>

              <div className="create-carrier-field">
                <label>
                  {t(
                    "fields.phoneNumberCountryCode.label"
                  )}
                </label>

                <Select
                  options={
                    phoneNumberOptions
                  }
                  value={
                    phoneNumberOptions.find(
                      (
                        option
                      ) =>
                        option.value ===
                        formData.phoneNumberCountryCode
                    ) ||
                    null
                  }
                  onChange={
                    handlePhoneCodeChange
                  }
                  formatOptionLabel={(
                    option
                  ) => (
                    <div className="create-carrier-option-with-icon">
                      <img
                        src={`https://flagcdn.com/w40/${option.code}.png`}
                        alt={
                          option.label
                        }
                        className="create-carrier-option-flag"
                      />

                      <span>
                        {
                          option.label
                        }
                      </span>
                    </div>
                  )}
                  placeholder={t(
                    "fields.phoneNumberCountryCode.placeholder"
                  )}
                  isClearable
                  styles={
                    customSelectStyles
                  }
                  classNamePrefix={
                    errors.phoneNumberCountryCode
                      ? "create-carrier-select-error"
                      : "create-carrier-select"
                  }
                />

                {errors.phoneNumberCountryCode && (
                  <p className="create-carrier-dropdown-field-error">
                    {
                      errors.phoneNumberCountryCode
                    }
                  </p>
                )}
              </div>

              <div className="create-carrier-field">
                <label htmlFor="phoneNumber">
                  {t(
                    "fields.phoneNumber.label"
                  )}
                </label>

                <input
                  type="text"
                  id="phoneNumber"
                  name="phoneNumber"
                  placeholder={t(
                    "fields.phoneNumber.placeholder"
                  )}
                  value={
                    formData.phoneNumber
                  }
                  onChange={
                    handleInputChange
                  }
                  className={`create-carrier-input ${
                    errors.phoneNumber
                      ? "create-carrier-input-error"
                      : ""
                  }`}
                />

                {errors.phoneNumber && (
                  <p className="create-carrier-field-error">
                    {
                      errors.phoneNumber
                    }
                  </p>
                )}
              </div>
            </div>

            {/* Additional Contacts */}
            <div className="create-carrier-subsection-header">
              <div>
                <h3>
                  {t(
                    "contacts.section_title"
                  )}
                </h3>

                <p>
                  {t(
                    "contacts.section_subtitle"
                  )}
                </p>
              </div>

              <button
                type="button"
                className="create-carrier-add-contact-button"
                onClick={
                  handleAddContact
                }
              >
                <FaPlus />

                <span>
                  {t(
                    "contacts.actions.add"
                  )}
                </span>
              </button>
            </div>

            {(formData.contacts ||
              []).length ===
            0 ? (
              <div className="create-carrier-empty-contacts">
                {t(
                  "contacts.empty"
                )}
              </div>
            ) : (
              <div className="create-carrier-extra-contacts">
                {(
                  formData.contacts ||
                  []
                ).map(
                  (
                    contact,
                    index
                  ) => (
                    <div
                      key={
                        index
                      }
                      className="create-carrier-extra-contact-block"
                    >
                      <div className="create-carrier-extra-contact-heading">
                        <strong>
                          {t(
                            "contacts.additional_title",
                            {
                              number:
                                index +
                                1,
                            }
                          )}
                        </strong>

                        <button
                          type="button"
                          className="create-carrier-remove-contact-button"
                          onClick={() =>
                            handleRemoveContact(
                              index
                            )
                          }
                          title={t(
                            "contacts.actions.remove"
                          )}
                          aria-label={t(
                            "contacts.actions.remove"
                          )}
                        >
                          <FaTrashAlt />
                        </button>
                      </div>

                      <div className="create-carrier-extra-contact-row">
                        <div className="create-carrier-field">
                          <label>
                            {t(
                              "contacts.fields.name"
                            )}
                          </label>

                          <input
                            type="text"
                            value={
                              contact.contactName ||
                              ""
                            }
                            onChange={(
                              event
                            ) =>
                              handleContactChange(
                                index,
                                "contactName",
                                event
                                  .target
                                  .value
                              )
                            }
                            placeholder={t(
                              "contacts.placeholders.name"
                            )}
                            className={`create-carrier-input ${
                              errors[
                                `contacts-${index}-contactName`
                              ]
                                ? "create-carrier-input-error"
                                : ""
                            }`}
                          />

                          {errors[
                            `contacts-${index}-contactName`
                          ] && (
                            <p className="create-carrier-field-error">
                              {
                                errors[
                                  `contacts-${index}-contactName`
                                ]
                              }
                            </p>
                          )}
                        </div>

                        <div className="create-carrier-field">
                          <label>
                            {t(
                              "contacts.fields.title"
                            )}
                          </label>

                          <input
                            type="text"
                            value={
                              contact.contactTitle ||
                              ""
                            }
                            onChange={(
                              event
                            ) =>
                              handleContactChange(
                                index,
                                "contactTitle",
                                event
                                  .target
                                  .value
                              )
                            }
                            placeholder={t(
                              "contacts.placeholders.title"
                            )}
                            className={`create-carrier-input ${
                              errors[
                                `contacts-${index}-contactTitle`
                              ]
                                ? "create-carrier-input-error"
                                : ""
                            }`}
                          />

                          {errors[
                            `contacts-${index}-contactTitle`
                          ] && (
                            <p className="create-carrier-field-error">
                              {
                                errors[
                                  `contacts-${index}-contactTitle`
                                ]
                              }
                            </p>
                          )}
                        </div>

                        <div className="create-carrier-field">
                          <label>
                            {t(
                              "contacts.fields.email"
                            )}
                          </label>

                          <input
                            type="email"
                            value={
                              contact.contactEmail ||
                              ""
                            }
                            onChange={(
                              event
                            ) =>
                              handleContactChange(
                                index,
                                "contactEmail",
                                event
                                  .target
                                  .value
                              )
                            }
                            placeholder={t(
                              "contacts.placeholders.email"
                            )}
                            className={`create-carrier-input ${
                              errors[
                                `contacts-${index}-contactEmail`
                              ]
                                ? "create-carrier-input-error"
                                : ""
                            }`}
                          />

                          {errors[
                            `contacts-${index}-contactEmail`
                          ] && (
                            <p className="create-carrier-field-error">
                              {
                                errors[
                                  `contacts-${index}-contactEmail`
                                ]
                              }
                            </p>
                          )}
                        </div>

                        <div className="create-carrier-field">
                          <label>
                            {t(
                              "contacts.fields.countryCode"
                            )}
                          </label>

                          <Select
                            options={
                              phoneNumberOptions
                            }
                            value={
                              phoneNumberOptions.find(
                                (
                                  option
                                ) =>
                                  option.value ===
                                  contact.phoneNumberCountryCode
                              ) ||
                              null
                            }
                            onChange={(
                              option
                            ) =>
                              handleContactChange(
                                index,
                                "phoneNumberCountryCode",
                                option
                                  ? option.value
                                  : ""
                              )
                            }
                            formatOptionLabel={(
                              option
                            ) => (
                              <div className="create-carrier-option-with-icon">
                                <img
                                  src={`https://flagcdn.com/w40/${option.code}.png`}
                                  alt={
                                    option.label
                                  }
                                  className="create-carrier-option-flag"
                                />

                                <span>
                                  {
                                    option.label
                                  }
                                </span>
                              </div>
                            )}
                            placeholder={t(
                              "contacts.placeholders.countryCode"
                            )}
                            isClearable
                            styles={
                              customSelectStyles
                            }
                            classNamePrefix={
                              errors[
                                `contacts-${index}-phoneNumberCountryCode`
                              ]
                                ? "create-carrier-select-error"
                                : "create-carrier-select"
                            }
                          />

                          {errors[
                            `contacts-${index}-phoneNumberCountryCode`
                          ] && (
                            <p className="create-carrier-dropdown-field-error">
                              {
                                errors[
                                  `contacts-${index}-phoneNumberCountryCode`
                                ]
                              }
                            </p>
                          )}
                        </div>

                        <div className="create-carrier-field">
                          <label>
                            {t(
                              "contacts.fields.phoneNumber"
                            )}
                          </label>

                          <input
                            type="text"
                            value={
                              contact.phoneNumber ||
                              ""
                            }
                            onChange={(
                              event
                            ) =>
                              handleContactChange(
                                index,
                                "phoneNumber",
                                event
                                  .target
                                  .value
                              )
                            }
                            placeholder={t(
                              "contacts.placeholders.phoneNumber"
                            )}
                            className={`create-carrier-input ${
                              errors[
                                `contacts-${index}-phoneNumber`
                              ]
                                ? "create-carrier-input-error"
                                : ""
                            }`}
                          />

                          {errors[
                            `contacts-${index}-phoneNumber`
                          ] && (
                            <p className="create-carrier-field-error">
                              {
                                errors[
                                  `contacts-${index}-phoneNumber`
                                ]
                              }
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  )
                )}
              </div>
            )}
          </section>

          {/* =========================================
              DOCUMENTS
              ========================================= */}
          <section
            ref={(
              node
            ) => {
              sectionRefs.current.documents =
                node;
            }}
            data-section="documents"
            className="create-carrier-section"
          >
            <div className="create-carrier-section-header">
              <span className="create-carrier-section-header__icon">
                <FaShieldAlt />
              </span>

              <div>
                <h2>
                  {t(
                    "nav.documents"
                  )}
                </h2>

                <p>
                  {t(
                    "section_subtitles.documents"
                  )}
                </p>
              </div>
            </div>

            <div className="create-carrier-documents-table">
              <div className="create-carrier-documents-header">
                <span>
                  {t(
                    "documents.document"
                  )}
                </span>

                <span>
                  {t(
                    "documents.action"
                  )}
                </span>

                <span>
                  {t(
                    "documents.validity"
                  )}
                </span>
              </div>

              {documentRows.map(
                (
                  document
                ) => {
                  const file =
                    files[
                      document.fileKey
                    ];

                  return (
                    <div
                      key={
                        document.fileKey
                      }
                      className={`create-carrier-document-row ${
                        errors[
                          document.fileKey
                        ] ||
                        errors[
                          document.expiryName
                        ]
                          ? "has-error"
                          : ""
                      }`}
                    >
                      <div className="create-carrier-document-info">
                        <span className="create-carrier-document-icon">
                          <FaFileAlt />
                        </span>

                        <div className="create-carrier-document-copy">
                          <span className="create-carrier-document-name">
                            {
                              document.label
                            }
                          </span>

                          {file ? (
                            <button
                              type="button"
                              className="create-carrier-document-file"
                              onClick={() =>
                                openLocalFile(
                                  file
                                )
                              }
                              title={
                                file.name
                              }
                            >
                              {
                                file.name
                              }
                            </button>
                          ) : (
                            <span className="create-carrier-document-empty">
                              {t(
                                "documents.no_file"
                              )}
                            </span>
                          )}

                          {errors[
                            document.fileKey
                          ] && (
                            <p className="create-carrier-field-error">
                              {
                                errors[
                                  document.fileKey
                                ]
                              }
                            </p>
                          )}
                        </div>
                      </div>

                      <div className="create-carrier-document-action">
                        <button
                          type="button"
                          className="create-carrier-document-change"
                          onClick={() =>
                            document
                              .getElementById(
                                document.fileKey
                              )
                              ?.click()
                          }
                        >
                          {file ? (
                            t(
                              "common.change"
                            )
                          ) : (
                            <>
                              <FaUpload />

                              {t(
                                "documents.upload"
                              )}
                            </>
                          )}
                        </button>

                        <input
                          type="file"
                          id={
                            document.fileKey
                          }
                          name={
                            document.fileKey
                          }
                          accept="image/jpeg,image/png,application/pdf"
                          onChange={
                            handleFileChange
                          }
                          className="create-carrier-hidden-input"
                        />
                      </div>

                      <div className="create-carrier-document-expiry">
                        <div className="create-carrier-custom-input-wrapper">
                          <input
                            type="date"
                            id={
                              document.expiryName
                            }
                            name={
                              document.expiryName
                            }
                            value={
                              document.expiryValue ||
                              ""
                            }
                            onChange={
                              handleInputChange
                            }
                            className={`create-carrier-date-input ${
                              errors[
                                document.expiryName
                              ]
                                ? "create-carrier-input-error"
                                : ""
                            }`}
                          />

                          <FaCalendarAlt
                            className="create-carrier-fixed-calendar"
                            onClick={(
                              event
                            ) => {
                              event.preventDefault();

                              const input =
                                document
                                  .getElementById(
                                    document.expiryName
                                  );

                              input?.focus();

                              input?.showPicker?.();
                            }}
                          />
                        </div>

                        {errors[
                          document.expiryName
                        ] && (
                          <p className="create-carrier-field-error">
                            {
                              errors[
                                document.expiryName
                              ]
                            }
                          </p>
                        )}
                      </div>
                    </div>
                  );
                }
              )}
            </div>
          </section>

          {/* =========================================
              BANKING & PAYMENT
              ========================================= */}
          <section
            ref={(
              node
            ) => {
              sectionRefs.current.billing =
                node;
            }}
            data-section="billing"
            className="create-carrier-section"
          >
            <div className="create-carrier-section-header">
              <span className="create-carrier-section-header__icon">
                <FaCreditCard />
              </span>

              <div>
                <h2>
                  {t(
                    "nav.billing"
                  )}
                </h2>

                <p>
                  {t(
                    "section_subtitles.billing"
                  )}
                </p>
              </div>
            </div>

            <div className="create-carrier-grid create-carrier-grid--2">
              <div className="create-carrier-field">
                <label htmlFor="accountHolderName">
                  {t(
                    "fields.accountHolderName.label"
                  )}
                </label>

                <input
                  type="text"
                  id="accountHolderName"
                  name="accountHolderName"
                  placeholder={t(
                    "fields.accountHolderName.placeholder"
                  )}
                  value={
                    formData.accountHolderName
                  }
                  onChange={
                    handleInputChange
                  }
                  className={`create-carrier-input ${
                    errors.accountHolderName
                      ? "create-carrier-input-error"
                      : ""
                  }`}
                />

                {errors.accountHolderName && (
                  <p className="create-carrier-field-error">
                    {
                      errors.accountHolderName
                    }
                  </p>
                )}
              </div>

              <div className="create-carrier-field">
                <label
                  htmlFor="accountNumber"
                  className="create-carrier-form-label-with-hint"
                >
                  <span>
                    {t(
                      "fields.accountNumber.label"
                    )}
                  </span>

                  <small>
                    {t(
                      "hints.accountNumber_min"
                    )}
                  </small>
                </label>

                <input
                  type="text"
                  id="accountNumber"
                  name="accountNumber"
                  placeholder={t(
                    "fields.accountNumber.placeholder"
                  )}
                  value={
                    formData.accountNumber
                  }
                  onChange={
                    handleInputChange
                  }
                  onBlur={() => {
                    if (
                      !formData.accountNumber
                    ) {
                      clearFieldError(
                        "accountNumber"
                      );
                    } else if (
                      formData.accountNumber
                        .length <
                      8
                    ) {
                      setErrors(
                        (
                          previous
                        ) => ({
                          ...previous,

                          accountNumber:
                            t(
                              "errors.min.accountNumber"
                            ),
                        })
                      );
                    } else {
                      clearFieldError(
                        "accountNumber"
                      );
                    }
                  }}
                  className={`create-carrier-input ${
                    errors.accountNumber
                      ? "create-carrier-input-error"
                      : ""
                  }`}
                />

                {errors.accountNumber && (
                  <p className="create-carrier-field-error">
                    {
                      errors.accountNumber
                    }
                  </p>
                )}
              </div>
            </div>

            <div className="create-carrier-grid create-carrier-grid--4">
              <div className="create-carrier-field">
                <label htmlFor="bankName">
                  {t(
                    "fields.bankName.label"
                  )}
                </label>

                <input
                  type="text"
                  id="bankName"
                  name="bankName"
                  placeholder={t(
                    "fields.bankName.placeholder"
                  )}
                  value={
                    formData.bankName
                  }
                  onChange={
                    handleInputChange
                  }
                  className={`create-carrier-input ${
                    errors.bankName
                      ? "create-carrier-input-error"
                      : ""
                  }`}
                />

                {errors.bankName && (
                  <p className="create-carrier-field-error">
                    {
                      errors.bankName
                    }
                  </p>
                )}
              </div>

              <div className="create-carrier-field">
                <label
                  htmlFor="iban"
                  className="create-carrier-form-label-with-hint"
                >
                  <span>
                    {t(
                      "fields.iban.label"
                    )}
                  </span>

                  <small>
                    {t(
                      "hints.iban_min"
                    )}
                  </small>
                </label>

                <input
                  type="text"
                  id="iban"
                  name="iban"
                  placeholder={t(
                    "fields.iban.placeholder"
                  )}
                  value={
                    formData.iban
                  }
                  onChange={
                    handleInputChange
                  }
                  className={`create-carrier-input ${
                    errors.iban
                      ? "create-carrier-input-error"
                      : ""
                  }`}
                />

                {errors.iban && (
                  <p className="create-carrier-field-error">
                    {
                      errors.iban
                    }
                  </p>
                )}
              </div>

              <div className="create-carrier-field">
                <label
                  htmlFor="swift_bic"
                  className="create-carrier-form-label-with-hint"
                >
                  <span>
                    {t(
                      "fields.swift_bic.label"
                    )}
                  </span>

                  <small>
                    {t(
                      "hints.swift_min"
                    )}
                  </small>
                </label>

                <input
                  type="text"
                  id="swift_bic"
                  name="swift_bic"
                  placeholder={t(
                    "fields.swift_bic.placeholder"
                  )}
                  value={
                    formData.swift_bic
                  }
                  onChange={
                    handleInputChange
                  }
                  className={`create-carrier-input ${
                    errors.swift_bic
                      ? "create-carrier-input-error"
                      : ""
                  }`}
                />

                {errors.swift_bic && (
                  <p className="create-carrier-field-error">
                    {
                      errors.swift_bic
                    }
                  </p>
                )}
              </div>

              <div className="create-carrier-field">
                <label>
                  {t(
                    "fields.currency.label"
                  )}
                </label>

                <Select
                  options={
                    currencyOptions
                  }
                  value={
                    currencyOptions.find(
                      (
                        option
                      ) =>
                        option.value ===
                        formData.currency
                    ) ||
                    null
                  }
                  onChange={
                    handleCurrencyChange
                  }
                  placeholder={t(
                    "fields.currency.placeholder"
                  )}
                  isClearable
                  isSearchable={
                    false
                  }
                  styles={
                    customSelectStyles
                  }
                  formatOptionLabel={(
                    option
                  ) => (
                    <div className="create-carrier-option-with-icon">
                      <img
                        src={`https://flagcdn.com/w40/${option.code}.png`}
                        alt={
                          option.label
                        }
                        className="create-carrier-option-flag"
                      />

                      <span>
                        {
                          option.label
                        }
                      </span>
                    </div>
                  )}
                  classNamePrefix={
                    errors.currency
                      ? "create-carrier-select-error"
                      : "create-carrier-select"
                  }
                />

                {errors.currency && (
                  <p className="create-carrier-dropdown-field-error">
                    {
                      errors.currency
                    }
                  </p>
                )}
              </div>
            </div>

            <div className="create-carrier-grid create-carrier-grid--4">
              <div className="create-carrier-field">
                <label>
                  {t(
                    "fields.paymentMethodsAccepted.label"
                  )}
                </label>

                <Select
                  options={
                    paymentOptions
                  }
                  isMulti
                  closeMenuOnSelect={
                    false
                  }
                  hideSelectedOptions={
                    false
                  }
                  value={
                    paymentOptions.filter(
                      (
                        option
                      ) =>
                        (
                          formData.paymentMethodsAccepted ||
                          []
                        ).includes(
                          option.value
                        )
                    )
                  }
                  onChange={(
                    selected
                  ) => {
                    setFormData(
                      (
                        previous
                      ) => ({
                        ...previous,

                        paymentMethodsAccepted:
                          selected
                            ? selected.map(
                                (
                                  option
                                ) =>
                                  option.value
                              )
                            : [],
                      })
                    );

                    clearFieldError(
                      "paymentMethodsAccepted"
                    );
                  }}
                  placeholder={t(
                    "fields.paymentMethodsAccepted.placeholder"
                  )}
                  styles={
                    multiSelectHorizontalStyles
                  }
                  classNamePrefix={
                    errors.paymentMethodsAccepted
                      ? "create-carrier-select-error"
                      : "create-carrier-select"
                  }
                />

                {errors.paymentMethodsAccepted && (
                  <p className="create-carrier-dropdown-field-error">
                    {
                      errors.paymentMethodsAccepted
                    }
                  </p>
                )}
              </div>

              <div className="create-carrier-field">
                <label>
                  {t(
                    "fields.paymentDueDate.label"
                  )}
                </label>

                <Select
                  options={
                    paymentDueDateOptions
                  }
                  value={
                    formData.paymentDueDate
                      ? {
                          value:
                            formData.paymentDueDate,

                          label:
                            t(
                              `options.payment_due_dates.${formData.paymentDueDate.replaceAll(
                                " ",
                                "_"
                              )}`
                            ),
                        }
                      : null
                  }
                  onChange={(
                    option
                  ) => {
                    setFormData(
                      (
                        previous
                      ) => ({
                        ...previous,

                        paymentDueDate:
                          option
                            ? option.value
                            : "",
                      })
                    );

                    clearFieldError(
                      "paymentDueDate"
                    );
                  }}
                  placeholder={t(
                    "fields.paymentDueDate.placeholder"
                  )}
                  isClearable
                  isSearchable={
                    false
                  }
                  styles={
                    customSelectStyles
                  }
                  classNamePrefix={
                    errors.paymentDueDate
                      ? "create-carrier-select-error"
                      : "create-carrier-select"
                  }
                />

                {errors.paymentDueDate && (
                  <p className="create-carrier-dropdown-field-error">
                    {
                      errors.paymentDueDate
                    }
                  </p>
                )}
              </div>

              <div className="create-carrier-field">
                <label>
                  {t(
                    "fields.discountTerms.label"
                  )}
                </label>

                <Select
                  options={
                    discountOptions
                  }
                  value={
                    formData.discountTerms
                      ? {
                          value:
                            formData.discountTerms,

                          label:
                            formData.discountTerms,
                        }
                      : null
                  }
                  onChange={(
                    option
                  ) => {
                    setFormData(
                      (
                        previous
                      ) => ({
                        ...previous,

                        discountTerms:
                          option
                            ? option.value
                            : "",
                      })
                    );

                    clearFieldError(
                      "discountTerms"
                    );
                  }}
                  placeholder={t(
                    "fields.discountTerms.placeholder"
                  )}
                  isClearable
                  isSearchable={
                    false
                  }
                  styles={
                    customSelectStyles
                  }
                  classNamePrefix={
                    errors.discountTerms
                      ? "create-carrier-select-error"
                      : "create-carrier-select"
                  }
                />

                {errors.discountTerms && (
                  <p className="create-carrier-dropdown-field-error">
                    {
                      errors.discountTerms
                    }
                  </p>
                )}
              </div>

              <div className="create-carrier-field">
                <label htmlFor="latePaymentPenalties">
                  {t(
                    "fields.latePaymentPenalties.label"
                  )}
                </label>

                <input
                  type="text"
                  id="latePaymentPenalties"
                  name="latePaymentPenalties"
                  placeholder={t(
                    "fields.latePaymentPenalties.placeholder"
                  )}
                  value={
                    formData.latePaymentPenalties
                  }
                  onChange={
                    handleInputChange
                  }
                  className={`create-carrier-input ${
                    errors.latePaymentPenalties
                      ? "create-carrier-input-error"
                      : ""
                  }`}
                />

                {errors.latePaymentPenalties && (
                  <p className="create-carrier-field-error">
                    {
                      errors.latePaymentPenalties
                    }
                  </p>
                )}
              </div>
            </div>

            <div className="create-carrier-section-divider" />

            <div className="create-carrier-subsection-heading">
              <h3>
                {t(
                  "sections.invoicing_prefs.title"
                )}
              </h3>

              <p>
                {t(
                  "section_subtitles.invoicing"
                )}
              </p>
            </div>

            <div className="create-carrier-grid create-carrier-grid--4">
              <div className="create-carrier-field">
                <label htmlFor="VAT_TaxInformation">
                  {t(
                    "fields.VAT_TaxInformation.label"
                  )}
                </label>

                <input
                  type="text"
                  id="VAT_TaxInformation"
                  name="VAT_TaxInformation"
                  placeholder={t(
                    "fields.VAT_TaxInformation.placeholder"
                  )}
                  value={
                    formData.VAT_TaxInformation
                  }
                  onChange={
                    handleInputChange
                  }
                  className={`create-carrier-input ${
                    errors.VAT_TaxInformation
                      ? "create-carrier-input-error"
                      : ""
                  }`}
                />

                {errors.VAT_TaxInformation && (
                  <p className="create-carrier-field-error">
                    {
                      errors.VAT_TaxInformation
                    }
                  </p>
                )}
              </div>

              <div className="create-carrier-field">
                <label htmlFor="iva">
                  {t(
                    "fields.iva.label"
                  )}
                </label>

                <input
                  type="number"
                  id="iva"
                  name="iva"
                  placeholder={t(
                    "fields.iva.placeholder"
                  )}
                  value={
                    formData.iva
                  }
                  onChange={
                    handleInputChange
                  }
                  onBlur={() => {
                    const normalized =
                      String(
                        formData.iva ||
                          ""
                      )
                        .trim()
                        .replace(
                          ",",
                          "."
                        );

                    if (
                      !normalized
                    ) {
                      clearFieldError(
                        "iva"
                      );

                      return;
                    }

                    const parsed =
                      Number(
                        normalized
                      );

                    if (
                      !Number.isFinite(
                        parsed
                      )
                    ) {
                      setErrors(
                        (
                          previous
                        ) => ({
                          ...previous,

                          iva:
                            t(
                              "errors.invalid.iva"
                            ),
                        })
                      );

                      return;
                    }

                    if (
                      parsed <
                        0 ||
                      parsed >
                        100
                    ) {
                      setErrors(
                        (
                          previous
                        ) => ({
                          ...previous,

                          iva:
                            t(
                              "errors.range.iva"
                            ),
                        })
                      );

                      return;
                    }

                    setFormData(
                      (
                        previous
                      ) => ({
                        ...previous,

                        iva:
                          parsed.toFixed(
                            2
                          ),
                      })
                    );

                    clearFieldError(
                      "iva"
                    );
                  }}
                  min="0"
                  max="100"
                  step="0.01"
                  className={`create-carrier-input ${
                    errors.iva
                      ? "create-carrier-input-error"
                      : ""
                  }`}
                />

                {errors.iva && (
                  <p className="create-carrier-field-error">
                    {
                      errors.iva
                    }
                  </p>
                )}
              </div>

              <div className="create-carrier-field">
                <label>
                  {t(
                    "fields.invoiceDeliveryMethod.label"
                  )}
                </label>

                <Select
                  options={
                    invoiceDeliveryOptions
                  }
                  isMulti
                  closeMenuOnSelect={
                    false
                  }
                  hideSelectedOptions={
                    false
                  }
                  value={
                    invoiceDeliveryOptions.filter(
                      (
                        option
                      ) =>
                        (
                          formData.invoiceDeliveryMethod ||
                          []
                        ).includes(
                          option.value
                        )
                    )
                  }
                  onChange={(
                    selected
                  ) => {
                    setFormData(
                      (
                        previous
                      ) => ({
                        ...previous,

                        invoiceDeliveryMethod:
                          selected
                            ? selected.map(
                                (
                                  option
                                ) =>
                                  option.value
                              )
                            : [],
                      })
                    );

                    clearFieldError(
                      "invoiceDeliveryMethod"
                    );
                  }}
                  placeholder={t(
                    "fields.invoiceDeliveryMethod.placeholder"
                  )}
                  isClearable
                  isSearchable={
                    false
                  }
                  styles={
                    multiSelectHorizontalStyles
                  }
                  classNamePrefix={
                    errors.invoiceDeliveryMethod
                      ? "create-carrier-select-error"
                      : "create-carrier-select"
                  }
                />

                {errors.invoiceDeliveryMethod && (
                  <p className="create-carrier-dropdown-field-error">
                    {
                      errors.invoiceDeliveryMethod
                    }
                  </p>
                )}
              </div>

              <div className="create-carrier-field">
                <label htmlFor="invoiceEmail">
                  {t(
                    "fields.invoiceEmail.label"
                  )}
                </label>

                <input
                  type="email"
                  id="invoiceEmail"
                  name="invoiceEmail"
                  placeholder={t(
                    "fields.invoiceEmail.placeholder"
                  )}
                  value={
                    formData.invoiceEmail
                  }
                  onChange={
                    handleInputChange
                  }
                  className={`create-carrier-input ${
                    errors.invoiceEmail
                      ? "create-carrier-input-error"
                      : ""
                  }`}
                />

                {errors.invoiceEmail && (
                  <p className="create-carrier-field-error">
                    {
                      errors.invoiceEmail
                    }
                  </p>
                )}
              </div>
            </div>

            <div className="create-carrier-grid create-carrier-grid--1">
              <div className="create-carrier-field">
                <label htmlFor="additionalNotes">
                  {t(
                    "fields.additionalNotes.label"
                  )}
                </label>

                <textarea
                  id="additionalNotes"
                  name="additionalNotes"
                  placeholder={t(
                    "fields.additionalNotes.placeholder"
                  )}
                  value={
                    formData.additionalNotes
                  }
                  onChange={(
                    event
                  ) => {
                    const value =
                      event.target.value.slice(
                        0,
                        500
                      );

                    setFormData(
                      (
                        previous
                      ) => ({
                        ...previous,

                        additionalNotes:
                          value,
                      })
                    );
                  }}
                  rows="4"
                  className="create-carrier-textarea-field"
                />

                <div className="create-carrier-character-counter">
                  {(
                    formData.additionalNotes ||
                    ""
                  ).length}{" "}
                  / 500
                </div>
              </div>
            </div>
          </section>
        </form>
      </div>
    </div>
  );
}

export default CreateCarrier;